import * as React from 'react';
import { OneButtonMessageBar } from './OneButtonMessageBar';
import { getString } from '../../utils/stringLoader';
import { MessageBarType } from '@fluentui/react';
import { getSocMarket } from '../../utils/statelessUtil';

interface IUpdateBannerProps {
  isTeams: boolean;
  updateDate: Date;
  handleButtonClick: () => void;
}
class UpdateBanner extends React.Component<IUpdateBannerProps> {
  private messageBarRef = React.createRef<HTMLDivElement>();

  handleDismiss = () => {
    if (this.messageBarRef.current) {
      this.messageBarRef.current.style.display = 'none';
    }
  };

  render() {
    const { isTeams, updateDate, handleButtonClick } = this.props;
    const formattedDate = updateDate.toLocaleDateString(getSocMarket(), { month: 'long', day: 'numeric' });

    return (
      <div ref={this.messageBarRef}>
        <OneButtonMessageBar
          isTeams={isTeams}
          content={getString('UpdateBanner_content').replace('{0}', formattedDate)}
          buttonText={getString('UpdateBanner_button')}
          messageBarType={MessageBarType.info}
          onDismiss={this.handleDismiss}
          onButtonClick={handleButtonClick}
        />
      </div>
    );
  }
}

export default UpdateBanner;
